


interface SolutionCardProps {
  title: string;
  description: string;
  image: string;
  alt: string;
  features: string[];
  industries: string[];
  onLearnMore: () => void;
}

export default function SolutionCard({
  title,
  description,
  image,
  alt,
  features,
  industries,
  onLearnMore,
}: SolutionCardProps) {
  return (
    <div className="bg-card rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">
      {/* Solution Title */}
      <div className="p-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-3">{title}</h3>
        
        {/* Solution Description */}
        <p className="text-gray-600 mb-4 leading-relaxed">{description}</p>
        
        {/* Industry Tags */}
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">Industries:</h4>
          <div className="flex flex-wrap gap-2">
            {industries.map((industry, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-blue-100 text-blue-800 text-xs font-medium rounded-full"
              >
                {industry}
              </span>
            ))}
          </div>
        </div>
        
        {/* Specifications Section */}
        <div className="mb-6">
          <h4 className="text-sm font-semibold text-gray-700 mb-2">Key Specifications:</h4>
          <ul className="space-y-2">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start">
                <svg
                  className="w-5 h-5 text-green-500 mr-2 flex-shrink-0 mt-0.5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span className="text-sm text-gray-600">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
        
        {/* Consultation CTA Button */}
        <button
          onClick={onLearnMore}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 shadow-sm hover:shadow-md"
        >
          Request Consultation
        </button>
      </div>
    </div>
  );
}